import { createAsyncThunk } from "@reduxjs/toolkit";
import { Organization } from "types/organization";

export const setOrganizationsThunk = createAsyncThunk<
  Organization[] | null,
  Organization[] | null
>(
  "organization/setOrganizationsThunk",
  async (organization, { rejectWithValue }) => {
    try {
      return organization;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const SelectOrganizationThunk = createAsyncThunk<
  Organization | null,
  Organization | null
>(
  "admin/SelectOrganizationThunk",
  async (organization, { rejectWithValue }) => {
    try {
      return organization;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
